import { useEffect, useState, useTransition } from "react"

import { selectExpireDate, selectIsConfirmationSendToModalOpen, selectSendToEmail } from "features/common/model/selectors/appSelectors"
import {
  AUTH_MODAL_MODE,
  setAuthModalMode,
  setIsAuthModalOpen,
  setIsConfirmationSendToModalOpen
} from 'features/common/model/slice/appSlice'
import { useAppDispatch, useAppSelector } from 'shared/config/store'
import { Button, Flex, Modal, Typography, CheckCircleFilled } from "shared/ui"
import styled from "styled-components"

import { resendMessageForApproveThunk } from "../model/slice/userSlice"


export const SignUpConfirmationSendToModal = () => {

  const isConfirmationSendToModalOpen = useAppSelector(selectIsConfirmationSendToModalOpen)
  const dispatch = useAppDispatch()
  const login = useAppSelector(selectSendToEmail)
  const email = login && login.split(':')[1] || login
  const expireDate = useAppSelector(selectExpireDate)
  const [resendTimer, setResendTimer] = useState(0)
  const [isPending, setIsPending] = useState(false)

  useEffect(() => {
    let timer: NodeJS.Timeout | null = null
    if (resendTimer > 0) {
      timer = setTimeout(() => setResendTimer(resendTimer - 1), 1000)
    }
    return () => {
      if (timer) clearTimeout(timer)
    }
  }, [resendTimer])

  const handleResend = () => {
    if (isPending || resendTimer > 0 || !login) return
    setResendTimer(60)
    setIsPending(true)
    dispatch(resendMessageForApproveThunk({ login }))
      .unwrap()
      .finally(() => {
        setIsPending(false)
      })
  }

  const handleClose = () => {
    return false
  }

  const handleSignUp = () => {
    dispatch(setIsConfirmationSendToModalOpen(false))
    dispatch(setAuthModalMode(AUTH_MODAL_MODE.SIGNUP))

    dispatch(setIsAuthModalOpen(true))
  }


  return (
    <Modal
      open={isConfirmationSendToModalOpen}
      footer={null}
      width={420}
      closable={false}
      centered
      destroyOnClose={true}
      onCancel={handleClose}
      styles={{
        mask: {
          backgroundColor: "transparent",
          background: "url('/images/sendToEmailBg.svg')",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center center",
        },
        content: {
          padding: 48,
        },
      }}
      wrapClassName="signup-confirmation-modal-wrapper"
    >
      <Flex vertical
        align="center"
        gap={24}
      >
        <SuccessIcon>
          <CheckCircleFilled style={{ fontSize: 60, color: "#52c41a" }} />
        </SuccessIcon>

        <Typography.Title level={3}
          style={{ textAlign: "center", margin: 0, color: "rgba(0, 0, 0, 0.85)", fontSize: 24, fontWeight: 600, lineHeight: "32px" }}
        >
          Confirmation sent

          to &quot;
          {email}
&quot;
        </Typography.Title>

        <Typography.Text style={{ textAlign: "center", color: "rgba(0, 0, 0, 0.65)", fontSize: 14, lineHeight: "22px" }}>
          Please check your email – we&apos;ve sent you a link
          <br />
          to confirm your account.


          {!!expireDate && (
            <span>
          The link is active until

              {' '}

              {expireDate}
.

              {' '}
            </span>
          )}
        </Typography.Text>

        <Button
          type="primary"
          block
          size="large"
          style={{ fontSize: 16, height: 40 }}
          onClick={handleResend}
          disabled= {resendTimer > 0 || isPending}
        >
          {resendTimer > 0 ? `Resend link after ${resendTimer} seconds` : 'Resend link'}
        </Button>

        <Typography.Text style={{ textAlign: "center" }}>
          Go to
          {' '}

          <SignUpLink onClick={handleSignUp}>
            Sign up
          </SignUpLink>
        </Typography.Text>
      </Flex>
    </Modal>
  )
}

const SuccessIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  width: 72px;
  height: 72px;
  margin-bottom: 8px;
  padding: 4px;
  box-sizing: border-box;
`

const SignUpLink = styled.span`
  color: #8F4EEB;
  cursor: pointer;
  text-decoration: underline;
`
